import { render } from "./ban-ve-ghe-phu.vue?vue&type=template&id=81465d62"
import script from "./ban-ve-ghe-phu.vue?vue&type=script&lang=js"
export * from "./ban-ve-ghe-phu.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__